/* ==========================================================================
   The Communicator — motion layer (anime.js v4)
   Particle product cards, add-to-cart fly-in, scramble text, hero reveal,
   AI waveform, animated FAQ. Hooks into Taiga's cart via 'ajaxProduct:added'.
   ========================================================================== */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function whenAnime(fn) {
    if (window.anime) return fn();
    var tries = 0;
    var t = setInterval(function () {
      if (window.anime || ++tries > 200) { clearInterval(t); if (window.anime) fn(); }
    }, 50);
  }

  function each(root, sel, fn) {
    Array.prototype.forEach.call(root.querySelectorAll(sel), fn);
  }

  /* ---------- Hero: words rise in ---------- */
  function initHero(root) {
    each(root, '.tc-hero', function (hero) {
      if (hero._tc || reduce) return;
      hero._tc = true;
      var A = window.anime;
      var words = hero.querySelectorAll('.tc-word');
      var ins = hero.querySelectorAll('[data-tc-hero-in]');
      A.utils.set(words, { y: '110%' });
      A.utils.set(ins, { opacity: 0 });
      A.createTimeline({ defaults: { ease: 'outExpo', duration: 1100 } })
        .add(words, { y: ['110%', '0%'], delay: A.stagger(90) })
        .add(ins, { opacity: [0, 1], y: [16, 0], delay: A.stagger(80) }, '-=800');
      // Headline decodes word by word as it rises, like the section labels
      var title = hero.querySelector('.tc-hero__title');
      var decode = function (again) {
        Array.prototype.forEach.call(words, function (w, i) {
          setTimeout(function () { scramble(w, again, true); }, i * (again ? 45 : 90));
        });
      };
      decode(false);
      if (title) {
        title.addEventListener('mouseenter', function () { decode(true); });
        title.addEventListener('click', function () { decode(true); });
      }
    });
  }

  /* ---------- Scramble text on scroll into view (and on hover) ---------- */
  function scramble(el, again, lock) {
    if (reduce || el._tcRun || el.children.length) return;
    el._tcRun = true;
    // lock: hold the word's width so big headline type doesn't jitter while it decodes
    if (lock) { el.style.width = el.getBoundingClientRect().width + 'px'; el.style.whiteSpace = 'nowrap'; }
    window.anime.animate(el, {
      textContent: window.anime.scrambleText({ chars: 'A-Z0-9#%/', revealRate: again ? 70 : 45 }),
      onComplete: function () { el._tcRun = false; if (lock) { el.style.width = ''; el.style.whiteSpace = ''; } }
    });
  }
  function initScramble(root) {
    var els = Array.prototype.filter.call(root.querySelectorAll('[data-tc-scramble]'), function (el) { return !el._tcS; });
    if (!els.length) return;
    var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { io.unobserve(en.target); scramble(en.target, false); }
      });
    }, { rootMargin: '0px 0px -10% 0px' }) : null;
    els.forEach(function (el) {
      el._tcS = true;
      el.addEventListener('mouseenter', function () { scramble(el, true); });
      if (io) io.observe(el);
    });
  }

  /* ---------- Particle product cards (photo <-> globe) ---------- */
  var SPRING_IN = { stiffness: 120, damping: 18, mass: 0.9 };
  var SPRING_OUT = { stiffness: 70, damping: 16, mass: 1 };
  var SPRING_SETTLE = { stiffness: 55, damping: 16, mass: 1 };

  function loadImage(src) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () { resolve(img); };
      img.onerror = reject;
      img.src = src;
    });
  }

  function setupCard(st) {
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w = st.media.clientWidth, h = st.media.clientHeight;
    if (!w || !h) return false;
    var W = Math.round(w * dpr), H = Math.round(h * dpr);
    st.cv.width = W; st.cv.height = H; st.W = W; st.H = H; st.cssW = w;
    st.ctx = st.cv.getContext('2d');
    var src = document.createElement('canvas');
    src.width = W; src.height = H;
    var sctx = src.getContext('2d', { willReadFrequently: true });
    sctx.fillStyle = '#CFC9BF';
    sctx.fillRect(0, 0, W, H);
    // object-fit: cover
    var iw = st.img.naturalWidth, ih = st.img.naturalHeight;
    var s = Math.max(W / iw, H / ih);
    sctx.drawImage(st.img, (W - iw * s) / 2, (H - ih * s) / 2, iw * s, ih * s);
    var px = sctx.getImageData(0, 0, W, H).data; // throws if the image is cross-origin without CORS
    st.src = src;
    var step = Math.max(3, Math.round(4 * dpr));
    var cols = Math.floor(W / step), rows = Math.floor(H / step), n = cols * rows;
    st.step = step; st.n = n; st.R = Math.min(W, H) * 0.36;
    st.ix = new Float32Array(n); st.iy = new Float32Array(n);
    st.ux = new Float32Array(n); st.uy = new Float32Array(n); st.uz = new Float32Array(n);
    st.cr = new Uint8Array(n); st.cg = new Uint8Array(n); st.cb = new Uint8Array(n);
    st.ph = new Float32Array(n); st.sp = new Float32Array(n);
    for (var i = 0; i < n; i++) {
      var c = i % cols, r = Math.floor(i / cols);
      var x = Math.min(W - 1, Math.floor((c + 0.5) * step)), y = Math.min(H - 1, Math.floor((r + 0.5) * step));
      var k = (y * W + x) * 4;
      st.ix[i] = c * step; st.iy[i] = r * step;
      st.cr[i] = px[k]; st.cg[i] = px[k + 1]; st.cb[i] = px[k + 2];
      var sy = 1 - (i / Math.max(n - 1, 1)) * 2, rr = Math.sqrt(Math.max(0, 1 - sy * sy)), a = i * 2.39996323;
      st.ux[i] = Math.cos(a) * rr; st.uy[i] = sy; st.uz[i] = Math.sin(a) * rr;
      st.ph[i] = Math.random() * Math.PI * 2; st.sp[i] = 0.7 + Math.random() * 0.35;
    }
    st.bg = [px[0], px[1], px[2]];
    st.imgData = st.ctx.createImageData(W, H);
    st.u32 = new Uint32Array(st.imgData.data.buffer);
    return true;
  }

  function drawCard(st, t) {
    var ctx = st.ctx, W = st.W, H = st.H, n = st.n, u32 = st.u32;
    var g = Math.max(0, st.g);
    if (g <= 0.0005) { ctx.globalAlpha = 1; ctx.drawImage(st.src, 0, 0); return; }
    var kb = Math.min(1, g) * 0.94;
    var bg0 = st.bg[0] + (14 - st.bg[0]) * kb, bg1 = st.bg[1] + (13 - st.bg[1]) * kb, bg2 = st.bg[2] + (11 - st.bg[2]) * kb;
    u32.fill(((255 << 24) | ((bg2 | 0) << 16) | ((bg1 | 0) << 8) | (bg0 | 0)) >>> 0);
    var yaw = st.yaw0 + t * 0.00035, cy = Math.cos(yaw), sy = Math.sin(yaw);
    var ct = Math.cos(-0.28), stl = Math.sin(-0.28);
    var sz = Math.max(2, Math.round(st.step * (1 - 0.45 * Math.min(1, g))));
    var cx = W / 2, cyy = H / 2, R = st.R, ts = t * 0.001;
    for (var pass = 0; pass < 2; pass++) {
      for (var i = 0; i < n; i++) {
        var x1 = st.ux[i] * cy + st.uz[i] * sy, z1 = -st.ux[i] * sy + st.uz[i] * cy;
        var y2 = st.uy[i] * ct - z1 * stl, z2 = st.uy[i] * stl + z1 * ct;
        if ((pass === 0) !== (z2 < 0)) continue;
        var sp = st.sp[i], ph = st.ph[i];
        var tx = Math.sin(ts * (sp + 0.6) + ph) * 0.045, ty = Math.cos(ts * (sp + 0.37) + ph * 1.71) * 0.035;
        var gx = cx + (x1 + tx) * R, gy = cyy - (y2 + ty) * R;
        var x = Math.round(st.ix[i] + (gx - st.ix[i]) * g), y = Math.round(st.iy[i] + (gy - st.iy[i]) * g);
        var f = 1 - Math.min(1, g) * 0.65 * (1 - (z2 + 1) / 2);
        var r = st.cr[i] * f + bg0 * (1 - f), gg = st.cg[i] * f + bg1 * (1 - f), b = st.cb[i] * f + bg2 * (1 - f);
        var col = ((255 << 24) | ((b | 0) << 16) | ((gg | 0) << 8) | (r | 0)) >>> 0;
        for (var dy = 0; dy < sz; dy++) {
          var yy = y + dy; if (yy < 0 || yy >= H) continue;
          var row = yy * W;
          for (var dx = 0; dx < sz; dx++) { var xx = x + dx; if (xx >= 0 && xx < W) u32[row + xx] = col; }
        }
      }
    }
    ctx.putImageData(st.imgData, 0, 0);
    var e = Math.min(1, Math.max(0, (g - 0.005) / 0.03));
    var fade = 1 - e * e * (3 - 2 * e);
    if (fade > 0) { ctx.globalAlpha = fade; ctx.drawImage(st.src, 0, 0); ctx.globalAlpha = 1; }
  }

  function kick(st) {
    if (st.raf) return;
    var loop = function (t) {
      drawCard(st, t);
      var busy = st.g > 0.0005 || (st.anim && !st.anim.completed);
      st.raf = busy ? requestAnimationFrame(loop) : 0;
      if (!busy) drawCard(st, t);
    };
    st.raf = requestAnimationFrame(loop);
  }

  function springTo(st, v, cfg, delay) {
    var A = window.anime;
    if (st.anim) st.anim.pause();
    st.anim = A.animate(st, { g: v, delay: delay || 0, ease: A.spring(cfg), onUpdate: function () { kick(st); }, onComplete: function () { kick(st); } });
    kick(st);
  }

  function initParticleCard(media, idx) {
    if (media._tc) return;
    var cv = media.querySelector('canvas');
    var imgEl = media.querySelector('img');
    var srcUrl = cv && cv.getAttribute('data-src');
    if (!cv || !srcUrl) return;
    media._tc = true;
    loadImage(srcUrl).then(function (img) {
      var st = { media: media, cv: cv, img: img, g: 0, raf: 0, yaw0: Math.random() * Math.PI * 2 };
      try { if (!setupCard(st)) return; } catch (err) { return; } // tainted or not laid out: keep the plain photo
      media._tcState = st;
      media.classList.add('is-particles');
      drawCard(st, performance.now());
      var card = media.closest('.tc-card') || media;
      card.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { st.hover = true; springTo(st, 1, SPRING_IN); } });
      card.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') { st.hover = false; springTo(st, 0, SPRING_OUT); } });
      media.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') { st.pressed = true; springTo(st, 1, SPRING_IN); } });
      var release = function () { if (st.pressed) { st.pressed = false; springTo(st, 0, SPRING_OUT); } };
      window.addEventListener('pointerup', release);
      window.addEventListener('pointercancel', release);
      // Intro: form the globe, then settle into the photo when the card first comes into view
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (!entries[0].isIntersecting) return;
          io.disconnect();
          st.g = 1; kick(st);
          springTo(st, 0, SPRING_SETTLE, 500 + idx * 160);
        }, { threshold: 0.35 });
        io.observe(media);
      }
      // Re-sample if the card is resized
      if ('ResizeObserver' in window) {
        var rt;
        new ResizeObserver(function () {
          clearTimeout(rt);
          rt = setTimeout(function () {
            if (Math.abs(media.clientWidth - st.cssW) > 2) { try { setupCard(st); drawCard(st, performance.now()); } catch (err) {} }
          }, 150);
        }).observe(media);
      }
    }).catch(function () { /* keep the plain photo */ });
  }

  function initParticles(root) {
    if (reduce) return;
    each(root, '.tc-card__media[data-tc-particles]', function (media, i) { initParticleCard(media, i % 4); });
    // Optional idle cycle, per section
    each(root, '[data-tc-cycle="true"]', function (sec) {
      if (sec._tcCycle) return;
      sec._tcCycle = true;
      var visible = false, idx = 0;
      if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }).observe(sec);
      setInterval(function () {
        if (!visible || document.hidden) return;
        var cards = Array.prototype.map.call(sec.querySelectorAll('.tc-card__media'), function (m) { return m._tcState; }).filter(function (s) { return s && !s.hover && !s.pressed; });
        if (!cards.length) return;
        var st = cards[idx++ % cards.length];
        springTo(st, 1, SPRING_IN);
        setTimeout(function () { if (!st.hover && !st.pressed) springTo(st, 0, SPRING_SETTLE); }, 1900);
      }, 3200);
    });
  }

  /* ---------- Add to cart with fly-in ---------- */
  function cartTarget() {
    var blip = document.querySelector('.site-header .cart-blip, .cart-blip');
    if (blip) return blip.closest('a') || blip;
    return document.querySelector('a[href="#drawer-cart"], a[href$="/cart"]');
  }

  function fly(card) {
    return new Promise(function (resolve) {
      var A = window.anime;
      var target = cartTarget();
      var media = card.querySelector('.tc-card__media');
      if (reduce || !A || !target || !media) return resolve();
      document.documentElement.classList.remove('sticky-header-hide');
      var img = media.querySelector('img');
      var flyer = document.createElement('div');
      flyer.className = 'tc-flyer';
      if (img) flyer.style.backgroundImage = 'url("' + (img.currentSrc || img.src) + '")';
      document.body.appendChild(flyer);
      var a = media.getBoundingClientRect();
      var sx = a.left + a.width / 2 - 30, sy = a.top + a.height / 2 - 40;
      setTimeout(function () {
        var c = target.getBoundingClientRect();
        var ex = c.left + c.width / 2 - 30, ey = c.top + c.height / 2 - 40;
        A.utils.set(flyer, { x: sx, y: sy, scale: 1.8, opacity: 1 });
        A.animate(flyer, {
          x: [{ to: (sx + ex) / 2, ease: 'outQuad', duration: 450 }, { to: ex, ease: 'inQuad', duration: 450 }],
          y: [{ to: Math.max(Math.min(sy, ey) - 140, 20), ease: 'outQuad', duration: 450 }, { to: ey, ease: 'inQuad', duration: 450 }],
          scale: [{ to: 1, duration: 450 }, { to: 0.2, duration: 450 }],
          rotate: [{ to: -10, duration: 450 }, { to: 0, duration: 450 }],
          opacity: [{ to: 1, duration: 760 }, { to: 0, duration: 140 }],
          onComplete: function () {
            flyer.remove();
            A.animate(target, { scale: [{ to: 1.25, duration: 160, ease: 'outQuad' }, { to: 1, duration: 420, ease: A.spring({ stiffness: 260, damping: 12 }) }] });
            resolve();
          }
        });
      }, 60);
    });
  }

  function initCart(root) {
    each(root, '[data-tc-add]', function (btn) {
      if (btn._tc) return;
      btn._tc = true;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var card = btn.closest('.tc-card');
        var sel = card && card.querySelector('select[data-tc-variant]');
        var id = sel ? sel.value : btn.getAttribute('data-variant');
        if (!id || btn.disabled) return;
        var label = btn.querySelector('.tc-add__label');
        var mark = btn.querySelector('.tc-add__mark');
        var live = card.querySelector('[data-tc-live]');
        var orig = label.textContent;
        btn.disabled = true;
        var url = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
        fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
        })
          .then(function (res) { return res.json().then(function (json) { if (!res.ok) throw new Error(json.description || 'Unavailable'); return json; }); })
          .then(function () {
            label.textContent = btn.getAttribute('data-added') || 'Added';
            if (mark) mark.textContent = '\u2713';
            btn.classList.add('is-added');
            if (live) live.textContent = label.textContent;
            if (navigator.vibrate && isPhone()) { try { navigator.vibrate(12); } catch (e) {} }
            return fly(card);
          })
          .then(function () { document.dispatchEvent(new CustomEvent('ajaxProduct:added')); })
          .catch(function (err) {
            label.textContent = 'Unavailable';
            if (live) live.textContent = err && err.message ? err.message : 'Unavailable';
          })
          .then(function () {
            setTimeout(function () {
              label.textContent = orig;
              if (mark) mark.textContent = '+';
              btn.classList.remove('is-added');
              btn.disabled = false;
            }, 2200);
          });
      });
    });
  }

  /* ---------- AI waveform ---------- */
  function initWave(root) {
    if (reduce) return;
    each(root, '.tc-ai__wave path', function (p) {
      if (p._tc) return;
      p._tc = true;
      var A = window.anime;
      A.animate(A.svg.createDrawable(p), { draw: ['0 0', '0 1'], duration: 2600, ease: 'inOutQuad', loop: true, alternate: true, loopDelay: 400 });
    });
  }

  /* ---------- FAQ: smooth open/close ---------- */
  function initFaq(root) {
    each(root, '.tc-faq details', function (d) {
      if (d._tc) return;
      d._tc = true;
      var summary = d.querySelector('summary');
      var body = d.querySelector('.tc-faq__body');
      if (!summary || !body || reduce) return;
      summary.addEventListener('click', function (e) {
        e.preventDefault();
        var A = window.anime;
        if (d.open) {
          A.animate(body, { height: [body.offsetHeight, 0], duration: 450, ease: 'outExpo', onComplete: function () { d.open = false; body.style.height = ''; } });
        } else {
          d.open = true;
          var h = body.scrollHeight;
          A.animate(body, { height: [0, h], duration: 500, ease: 'outExpo', onComplete: function () { body.style.height = ''; } });
        }
      });
    });
  }

  /* ---------- Size picker: show the chosen size in the styled box ---------- */
  function initSizes(root) {
    each(root, '.tc-size select', function (sel) {
      if (sel._tc) return;
      sel._tc = true;
      var out = sel.parentNode.querySelector('.tc-size__value');
      var sync = function () {
        var opt = sel.options[sel.selectedIndex];
        if (out && opt) out.textContent = opt.text;
      };
      sel.addEventListener('change', sync);
      sync(); // browsers can restore a previous choice on back/forward
    });
  }

  /* ---------- Header logo: white, blending to a second color as you scroll ---------- */
  function parseColor(c) {
    c = String(c || '').trim();
    if (c.charAt(0) === '#') {
      if (c.length === 4) c = '#' + c[1] + c[1] + c[2] + c[2] + c[3] + c[3];
      return [1, 3, 5].map(function (i) { return parseInt(c.substr(i, 2), 16) || 0; });
    }
    var m = c.match(/[\d.]+/g);
    return m && m.length >= 3 ? m.slice(0, 3).map(Number) : [255, 255, 255];
  }

  // Turn the uploaded logo into a same-origin alpha mask. Works for transparent PNGs (keeps their
  // alpha) and for logos on a solid background (the background colour becomes transparent).
  function buildLogoMask(src) {
    return new Promise(function (resolve) {
      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.onload = function () {
        try {
          var s = Math.min(1, 800 / Math.max(im.naturalWidth, im.naturalHeight));
          var w = Math.max(1, Math.round(im.naturalWidth * s)), h = Math.max(1, Math.round(im.naturalHeight * s));
          var cv = document.createElement('canvas'); cv.width = w; cv.height = h;
          var x = cv.getContext('2d', { willReadFrequently: true });
          x.drawImage(im, 0, 0, w, h);
          var d = x.getImageData(0, 0, w, h), p = d.data;
          var transparent = p[3] < 20;
          var cr = p[0], cg = p[1], cb = p[2];
          for (var i = 0; i < p.length; i += 4) {
            var a = transparent ? p[i + 3] : Math.min(255, (Math.abs(p[i] - cr) + Math.abs(p[i + 1] - cg) + Math.abs(p[i + 2] - cb)) * 1.6);
            p[i] = p[i + 1] = p[i + 2] = 0; p[i + 3] = a;
          }
          x.putImageData(d, 0, 0);
          resolve(cv.toDataURL('image/png'));
        } catch (err) { resolve(null); } // image not readable: keep the plain white version
      };
      im.onerror = function () { resolve(null); };
      im.src = src;
    });
  }

  function initLogo() {
    if (document.documentElement._tcLogo) return;
    document.documentElement._tcLogo = true;
    each(document, '.site-logo.--image', function (img) {
      var go = function () {
        buildLogoMask(img.currentSrc || img.src).then(function (url) {
          if (!url) return;
          // decode the mask first so there is no blank frame while swapping in the tint
          var pre = new Image();
          pre.src = url;
          (pre.decode ? pre.decode() : Promise.resolve()).catch(function () {}).then(function () {
            img.style.setProperty('--tc-logo-src', 'url("' + url + '")');
            requestAnimationFrame(function () { img.classList.add('tc-logo-tint'); });
          });
        });
      };
      if (img.complete && img.naturalWidth) go(); else img.addEventListener('load', go, { once: true });
    });
    var cfg = window.tcLogo || {};
    var from = parseColor(cfg.top || '#ffffff'), to = parseColor(cfg.scrolled || '#6fb3d2');
    var dist = Math.max(50, +cfg.distance || 600);
    var queued = false;
    var paint = function () {
      queued = false;
      var t = Math.min(1, Math.max(0, (window.scrollY || 0) / dist));
      var e = t * t * (3 - 2 * t);
      var c = from.map(function (v, i) { return Math.round(v + (to[i] - v) * e); });
      document.documentElement.style.setProperty('--tc-logo-color', 'rgb(' + c.join(',') + ')');
    };
    window.addEventListener('scroll', function () { if (!queued) { queued = true; requestAnimationFrame(paint); } }, { passive: true });
    paint();
  }

  /* ---------- Mesh-node backdrop (collection pages) ---------- */
  function initMesh(root) {
    each(root, 'canvas.tc-mesh', function (cv) {
      if (cv._tc) return;
      cv._tc = true;
      var hud = document.querySelector('.tc-mesh-hud[data-for="' + cv.id + '"]');
      // Replace any older copy (theme editor re-renders), then lift the canvas + readout onto <body>.
      // Themes animate sections with CSS transforms, which would trap a fixed canvas inside a 0px-tall section.
      Array.prototype.forEach.call(document.querySelectorAll('body > .tc-mesh, body > .tc-mesh-hud'), function (el) {
        if ((el.id === cv.id || el.getAttribute('data-for') === cv.id) && el !== cv && el !== hud) { if (el._tcStop) el._tcStop(); el.remove(); }
      });
      document.body.insertBefore(cv, document.body.firstChild);
      if (hud) document.body.insertBefore(hud, cv.nextSibling);
      var col = parseColor(cv.getAttribute('data-color') || '#6fb3d2');
      var rgb = col.join(',');
      var density = +cv.getAttribute('data-density') || 55;
      var speed = +cv.getAttribute('data-speed'); if (isNaN(speed)) speed = 1;
      var L = +cv.getAttribute('data-link') || 150;
      var op = (+cv.getAttribute('data-opacity') || 60) / 100;
      var ctx = cv.getContext('2d');
      var W, H, nodes = [], packets = [], mouse = null, raf = 0, prev = 0;

      function build() {
        var dpr = Math.min(window.devicePixelRatio || 1, 1.5);
        W = window.innerWidth; H = window.innerHeight;
        cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        var n = Math.max(12, Math.round(density * (W * H) / (1440 * 900)));
        nodes = [];
        for (var i = 0; i < n; i++) {
          nodes.push({ x: Math.random() * W, y: Math.random() * H, vx: (Math.random() - 0.5) * 0.22, vy: (Math.random() - 0.5) * 0.22, r: 1.1 + Math.random() * 1.2, gw: i % 11 === 0, ph: Math.random() * 6.28 });
        }
        packets = [];
      }

      function draw(t) {
        var dt = prev ? Math.min(50, t - prev) : 16; prev = t;
        ctx.clearRect(0, 0, W, H);
        var i, j, a, b, dx, dy, d, links = 0, L2 = L * L;
        for (i = 0; i < nodes.length; i++) {
          a = nodes[i];
          a.x += a.vx * speed * dt * 0.06; a.y += a.vy * speed * dt * 0.06;
          if (a.x < -20) a.x = W + 20; else if (a.x > W + 20) a.x = -20;
          if (a.y < -20) a.y = H + 20; else if (a.y > H + 20) a.y = -20;
        }
        ctx.lineWidth = 1;
        for (i = 0; i < nodes.length; i++) {
          a = nodes[i];
          for (j = i + 1; j < nodes.length; j++) {
            b = nodes[j]; dx = a.x - b.x; dy = a.y - b.y; d = dx * dx + dy * dy;
            if (d < L2) {
              d = Math.sqrt(d); links++;
              ctx.strokeStyle = 'rgba(' + rgb + ',' + ((1 - d / L) * 0.32 * op).toFixed(3) + ')';
              ctx.beginPath(); ctx.moveTo(a.x, a.y); ctx.lineTo(b.x, b.y); ctx.stroke();
              if (speed > 0 && Math.random() < 0.00025 * dt && packets.length < 14) packets.push({ a: a, b: b, t: 0 });
            }
          }
          if (mouse) {
            dx = a.x - mouse.x; dy = a.y - mouse.y; d = Math.sqrt(dx * dx + dy * dy);
            if (d < L * 1.3) {
              ctx.strokeStyle = 'rgba(' + rgb + ',' + ((1 - d / (L * 1.3)) * 0.6 * op).toFixed(3) + ')';
              ctx.beginPath(); ctx.moveTo(a.x, a.y); ctx.lineTo(mouse.x, mouse.y); ctx.stroke();
            }
          }
        }
        // data packets travelling along live links
        for (i = packets.length - 1; i >= 0; i--) {
          var pk = packets[i]; pk.t += dt / 1400;
          if (pk.t >= 1) { packets.splice(i, 1); continue; }
          ctx.fillStyle = 'rgba(' + rgb + ',' + (0.9 * op).toFixed(3) + ')';
          ctx.fillRect(pk.a.x + (pk.b.x - pk.a.x) * pk.t - 1.5, pk.a.y + (pk.b.y - pk.a.y) * pk.t - 1.5, 3, 3);
        }
        // nodes; every 11th is a gateway: square with a slow ping
        for (i = 0; i < nodes.length; i++) {
          a = nodes[i];
          if (a.gw) {
            var pulse = (Math.sin(t * 0.0018 + a.ph) + 1) / 2;
            ctx.strokeStyle = 'rgba(' + rgb + ',' + ((1 - pulse) * 0.5 * op).toFixed(3) + ')';
            ctx.beginPath(); ctx.arc(a.x, a.y, 5 + pulse * 12, 0, 6.2832); ctx.stroke();
            ctx.fillStyle = 'rgba(' + rgb + ',' + (0.95 * op).toFixed(3) + ')';
            ctx.fillRect(a.x - 3, a.y - 3, 6, 6);
          } else {
            ctx.fillStyle = 'rgba(' + rgb + ',' + (0.7 * op).toFixed(3) + ')';
            ctx.beginPath(); ctx.arc(a.x, a.y, a.r, 0, 6.2832); ctx.fill();
          }
        }
        if (hud && (!hud._t || t - hud._t > 700)) { hud._t = t; hud.textContent = 'Mesh \u00b7 N=' + nodes.length + ' \u00b7 Links=' + links + ' \u00b7 Active'; }
      }

      function loop(t) { draw(t); raf = requestAnimationFrame(loop); }
      function start() { if (!raf && !reduce && !document.hidden) { prev = 0; raf = requestAnimationFrame(loop); } }
      function stop() { if (raf) cancelAnimationFrame(raf); raf = 0; }

      build();
      draw(performance.now());
      start();
      cv._tcStop = stop;
      var rt;
      window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { build(); draw(performance.now()); }, 200); });
      document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });
      window.addEventListener('pointermove', function (e) { if (e.pointerType === 'mouse') mouse = { x: e.clientX, y: e.clientY }; }, { passive: true });
      document.addEventListener('pointerleave', function () { mouse = null; });
      if (reduce) window.addEventListener('pointermove', function () { draw(performance.now()); }, { passive: true });
    });
  }

  /* ---------- Mobile layer: reveals, tap feedback, swipe rows, hero scroll ---------- */
  var isPhone = function () { return window.matchMedia && window.matchMedia('(max-width: 767px)').matches; };

  // Cards/tiles/rows spring in with a stagger when their section scrolls into view
  var REVEAL = '.tc-head, .tc-card, .tc-tile, .tc-list__item, .tc-lead, .tc-ai__card, .tc-gear, .tc-guide, .tc-faq details, .tc-signup__form, .tc-look__body';
  function initReveals(root) {
    if (reduce || !('IntersectionObserver' in window)) return;
    var A = window.anime;
    each(root, '.tc-section, .tc-look', function (sec) {
      if (sec._tcRev) return;
      sec._tcRev = true;
      if (sec.getBoundingClientRect().top < window.innerHeight * 0.9) return; // already on screen: never hide it
      var items = Array.prototype.slice.call(sec.querySelectorAll(REVEAL));
      items = items.filter(function (el) { return !(el.parentElement && el.parentElement.matches(GRIDS)); }); // grids ripple in instead
      if (!items.length) return;
      A.utils.set(items, { opacity: 0, y: 34, scale: 0.97 });
      var io = new IntersectionObserver(function (en) {
        if (!en[0].isIntersecting) return;
        io.disconnect();
        A.animate(items, { opacity: 1, y: 0, scale: 1, delay: A.stagger(55, { start: 40 }), ease: A.spring({ stiffness: 170, damping: 17 }) });
      }, { threshold: 0.12 });
      io.observe(sec);
    });
  }

  // Native-app press feel: sink on touch, spring back on release
  var PRESS = '.tc-btn, .tc-add, .tc-size, .tc-card__media, .tc-tile, .tc-ai__card, .tc-gear, .tc-guide, .tc-list__item, .tc-lead, .swatch, .tc-signup__row button, .tc-faq summary';
  function initPress() {
    if (reduce || document.documentElement._tcPress) return;
    document.documentElement._tcPress = true;
    var A = window.anime, cur = null;
    var up = function () {
      if (!cur) return;
      A.animate(cur, { scale: 1, ease: A.spring({ stiffness: 420, damping: 13 }) });
      cur = null;
    };
    document.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' || !isPhone()) return;
      var el = e.target.closest(PRESS);
      if (!el) return;
      cur = el;
      A.animate(el, { scale: 0.955, duration: 110, ease: 'outQuad' });
    }, { passive: true });
    ['pointerup', 'pointercancel'].forEach(function (t) { document.addEventListener(t, up, { passive: true }); });
    document.addEventListener('scroll', up, { passive: true });
  }

  // Swipe rows: progress bar + a one-time "peek" so people know they can swipe
  function initSwipes(root) {
    if (!isPhone()) return;
    var A = window.anime;
    each(root, '.tc-swipe', function (row) {
      if (row._tcSw || row.scrollWidth <= row.clientWidth + 8) return;
      row._tcSw = true;
      var bar = document.createElement('div');
      bar.className = 'tc-swipe-bar'; bar.setAttribute('aria-hidden', 'true');
      bar.appendChild(document.createElement('i'));
      row.parentNode.insertBefore(bar, row.nextSibling);
      var sync = function () {
        var w = bar.clientWidth, ratio = row.clientWidth / row.scrollWidth, thumb = Math.max(24, w * ratio);
        var max = row.scrollWidth - row.clientWidth, pos = max > 0 ? (row.scrollLeft / max) * (w - thumb) : 0;
        bar.style.setProperty('--tc-thumb', thumb + 'px');
        bar.style.setProperty('--tc-pos', pos + 'px');
      };
      row.addEventListener('scroll', function () { requestAnimationFrame(sync); }, { passive: true });
      window.addEventListener('resize', sync);
      sync();
      if (reduce || !('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (en) {
        if (!en[0].isIntersecting || row.scrollLeft > 0) return;
        io.disconnect();
        var kids = Array.prototype.slice.call(row.children, 0, 3);
        setTimeout(function () {
          if (row.scrollLeft > 0) return;
          A.animate(kids, { x: [{ to: -38, duration: 360, ease: 'outQuad' }, { to: 0, ease: A.spring({ stiffness: 260, damping: 12 }) }], delay: A.stagger(40) });
        }, 650);
      }, { threshold: 0.6 });
      io.observe(row);
    });
  }

  // Hero: headline lifts and fades, video eases in as you scroll past
  function initHeroScroll() {
    if (reduce || !isPhone() || document.documentElement._tcHeroSc) return;
    var hero = document.querySelector('.tc-hero');
    if (!hero) return;
    document.documentElement._tcHeroSc = true;
    var copy = hero.querySelector('.tc-hero__inner'), bg = hero.querySelector('.tc-hero__bg'), queued = false;
    var paint = function () {
      queued = false;
      var h = hero.offsetHeight || 1, y = Math.min(h, Math.max(0, window.scrollY - hero.offsetTop));
      var t = y / h;
      if (copy) { copy.style.transform = 'translate3d(0,' + (-y * 0.35).toFixed(1) + 'px,0)'; copy.style.opacity = (1 - t * 1.1).toFixed(3); }
      if (bg) bg.style.transform = 'scale(' + (1 + t * 0.12).toFixed(4) + ')';
    };
    window.addEventListener('scroll', function () { if (!queued) { queued = true; requestAnimationFrame(paint); } }, { passive: true });
    paint();
  }

  function initMobile(root) {
    if (!isPhone()) return;
    initReveals(root);
    initPress();
    initSwipes(root);
    initHeroScroll();
  }

  /* ==========================================================================
     Signal layer — built on anime.js utilities
     damp/lerp (target lock) · padStart (DTG + readouts) · stagger grid (radar ripple)
     shuffle (decrypt reveals) · createSeededRandom (signal signatures) · snap/mapRange (article progress)
     ========================================================================== */
  var toArr = function (l) { return Array.prototype.slice.call(l || []); };
  var pad = function (n, len) { return window.anime.utils.padStart(String(n), len || 2, '0'); };
  var below = function (el) { return el.getBoundingClientRect().top > window.innerHeight * 0.92; };
  var onView = function (el, fn, thr) {
    if (!('IntersectionObserver' in window)) return fn();
    var io = new IntersectionObserver(function (en) {
      if (!en[0].isIntersecting) return;
      io.disconnect(); fn();
    }, { threshold: thr || 0.15 });
    io.observe(el);
  };

  // 1 · Target lock: corner brackets glide after the cursor (damp) and lock onto cards
  var LOCK = '.tc-card, .tc-tile, .tc-ai__card, .tc-gear, .tc-guide, .tc-lead, .card--product, .card--article';
  function initLock() {
    if (reduce || document.documentElement._tcLock || !document.body) return;
    document.documentElement._tcLock = true;
    var u = window.anime.utils;
    var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
    var el = document.createElement('div');
    el.className = 'tc-lock'; el.setAttribute('aria-hidden', 'true');
    el.innerHTML = '<i class="tl"></i><i class="tr"></i><i class="bl"></i><i class="br"></i><b></b>';
    document.body.appendChild(el);
    var tag = el.querySelector('b');
    var cur = { x: -99, y: -99, w: 22, h: 22, o: 0 }, tgt = { x: -99, y: -99, w: 22, h: 22, o: 0 };
    var target = null, mx = -99, my = -99, raf = 0, last = 0, locked = false, releaseT = 0;
    var aim = function () {
      if (target && target.isConnected) {
        var r = target.getBoundingClientRect(), p = 6;
        tgt.x = r.left - p; tgt.y = r.top - p; tgt.w = r.width + p * 2; tgt.h = r.height + p * 2; tgt.o = 1;
      } else {
        target = null;
        tgt.w = 22; tgt.h = 22; tgt.x = mx - 11; tgt.y = my - 11; tgt.o = 0;
      }
    };
    var frame = function (t) {
      var dt = Math.min(64, last ? t - last : 16); last = t;
      aim();
      cur.x = u.damp(cur.x, tgt.x, dt, 0.22); cur.y = u.damp(cur.y, tgt.y, dt, 0.22);
      cur.w = u.damp(cur.w, tgt.w, dt, 0.2); cur.h = u.damp(cur.h, tgt.h, dt, 0.2);
      cur.o = u.damp(cur.o, tgt.o, dt, 0.18);
      el.style.transform = 'translate3d(' + cur.x.toFixed(1) + 'px,' + cur.y.toFixed(1) + 'px,0)';
      el.style.width = cur.w.toFixed(1) + 'px'; el.style.height = cur.h.toFixed(1) + 'px';
      el.style.opacity = cur.o.toFixed(3);
      var near = target && Math.abs(cur.x - tgt.x) + Math.abs(cur.y - tgt.y) + Math.abs(cur.w - tgt.w) < 3;
      if (near !== locked) { locked = !!near; el.classList.toggle('is-locked', locked); }
      if (!target && cur.o < 0.01) { raf = 0; last = 0; el.style.opacity = '0'; return; }
      raf = requestAnimationFrame(frame);
    };
    var wake = function () { if (!raf) raf = requestAnimationFrame(frame); };
    var setTarget = function (next) {
      if (next === target) return;
      target = next;
      if (target) {
        var all = toArr(document.querySelectorAll(LOCK)).filter(function (n) { return n.offsetWidth; });
        tag.textContent = 'TGT ' + pad(all.indexOf(target) + 1) + ' \u00b7 LOCK';
      }
      wake();
    };
    document.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse' || !fine.matches) return;
      mx = e.clientX; my = e.clientY;
      setTarget(e.target.closest ? e.target.closest(LOCK) : null);
      wake();
    }, { passive: true });
    document.documentElement.addEventListener('mouseleave', function () { setTarget(null); });
    // Phones: snap straight onto the tapped card, then let go
    document.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse') return;
      var hit = e.target.closest ? e.target.closest(LOCK) : null;
      if (!hit) return;
      var r = hit.getBoundingClientRect();
      mx = r.left + r.width / 2; my = r.top + r.height / 2;
      cur.x = r.left - 18; cur.y = r.top - 18; cur.w = r.width + 36; cur.h = r.height + 36; cur.o = 0.4;
      setTarget(hit);
      clearTimeout(releaseT);
      releaseT = setTimeout(function () { setTarget(null); }, 900);
    }, { passive: true });
  }

  // 2 · Live date-time group next to REC, e.g. 271944Z SEP 26 :32
  var MON = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
  function initDtg(root) {
    each(root, '[data-tc-dtg]', function (el) {
      if (el._tc) return; el._tc = true;
      el.innerHTML = '<span></span><s></s>';
      var main = el.firstChild, sec = el.lastChild;
      var tick = function () {
        var d = new Date();
        main.textContent = pad(d.getUTCDate()) + pad(d.getUTCHours()) + pad(d.getUTCMinutes()) + 'Z ' + MON[d.getUTCMonth()] + ' ' + pad(d.getUTCFullYear() % 100);
        sec.textContent = reduce ? '' : pad(d.getUTCSeconds());
        if (el.isConnected) setTimeout(tick, reduce ? 60000 - d.getUTCSeconds() * 1000 : 1000 - d.getMilliseconds());
      };
      tick();
    });
  }

  // 2 · Zero-padded readouts: 01/04 on New Releases, cart count 02
  function initReadouts(root) {
    each(root, '.tc-new .tc-products', function (row) {
      var cards = toArr(row.querySelectorAll('.tc-card'));
      cards.forEach(function (c, i) {
        var m = c.querySelector('.tc-card__media');
        if (!m || m.querySelector('.tc-idx')) return;
        var s = document.createElement('span');
        s.className = 'tc-idx'; s.setAttribute('aria-hidden', 'true');
        s.innerHTML = '<em>' + pad(i + 1) + '</em>/' + pad(cards.length);
        m.appendChild(s);
      });
    });
    var blip = document.querySelector('.cart-blip');
    if (blip && !blip._tcPad) {
      blip._tcPad = true;
      var fix = function () {
        var n = parseInt(blip.textContent, 10);
        if (isNaN(n)) return;
        var want = pad(n);
        if (blip.textContent.trim() !== want) blip.textContent = want;
      };
      fix();
      new MutationObserver(fix).observe(blip, { childList: true, characterData: true, subtree: true });
    }
  }

  // 3 · Radar ripple: grids appear as a pulse from the centre; taps ping outward from the card
  var GRIDS = '.tc-new .tc-products, .tc-shop__big, .tc-shop__small, .tc-loadout__grid, #product-grid-ajax.grid, .grid[data-id]';
  var gridItems = function (g) {
    return toArr(g.children).filter(function (n) { return n.offsetWidth && !n.classList.contains('tc-swipe-bar') && n.nodeName !== 'SCRIPT'; });
  };
  var gridDims = function (items) {
    var tops = [];
    items.forEach(function (n) { var t = Math.round(n.offsetTop); if (tops.indexOf(t) < 0) tops.push(t); });
    var rows = Math.max(1, tops.length);
    return [rows, Math.max(1, Math.ceil(items.length / rows))];
  };
  function ripple(g, from, hidden) {
    var A = window.anime, items = gridItems(g);
    if (!items.length) return;
    A.animate(items, {
      opacity: hidden ? [0, 1] : 1, scale: [0.9, 1],
      delay: A.stagger(75, { grid: gridDims(items), from: from == null ? 'center' : from }),
      duration: 750, ease: 'outExpo'
    });
  }
  function initRipples(root) {
    if (reduce) return;
    var A = window.anime;
    each(document, GRIDS, function (g) {
      if (g._tcRip || !(root === document || root.contains(g))) return;
      g._tcRip = true;
      var items = gridItems(g);
      if (items.length > 1 && below(g)) {
        A.utils.set(items, { opacity: 0 });
        onView(g, function () { ripple(g, null, true); }, 0.12);
      }
      // collection grids re-render on filter/sort: ripple the new results in
      if (g.id === 'product-grid-ajax') {
        new MutationObserver(function (m) {
          if (m.some(function (r) { return r.addedNodes.length; })) ripple(g, null, true);
        }).observe(g, { childList: true });
      }
      g.addEventListener('pointerdown', function (e) {
        var list = gridItems(g), hit = e.target.closest ? e.target.closest(LOCK) : null;
        var idx = hit ? list.indexOf(hit.parentElement === g ? hit : list.filter(function (n) { return n.contains(hit); })[0]) : -1;
        if (idx < 0 || list.length < 2) return;
        A.animate(list, {
          y: [{ to: -6, duration: 150, ease: 'outQuad' }, { to: 0, duration: 520, ease: 'outElastic(1, .5)' }],
          delay: A.stagger(60, { grid: gridDims(list), from: idx })
        });
      }, { passive: true });
    });
  }

  // 4 · Decrypt reveals: photos fill in block by block (shuffle); headings resolve letter by letter
  var PHOTOS = '.tc-card__media, #product-grid-ajax .card-media, .tc-lead__media, .card--article .card-media';
  function decryptPhoto(media) {
    if (media._tcBlk) return;
    media._tcBlk = true;
    var A = window.anime, u = A.utils;
    var w = media.offsetWidth, h = media.offsetHeight;
    if (!w || !h) return;
    var cols = w > 500 ? 10 : 6, rows = Math.max(3, Math.round(cols * h / w));
    var wrap = document.createElement('span');
    wrap.className = 'tc-blocks'; wrap.setAttribute('aria-hidden', 'true');
    wrap.style.gridTemplateColumns = 'repeat(' + cols + ',1fr)';
    wrap.style.gridTemplateRows = 'repeat(' + rows + ',1fr)';
    var cells = [];
    for (var i = 0; i < cols * rows; i++) { var c = document.createElement('span'); cells.push(c); wrap.appendChild(c); }
    media.appendChild(wrap);
    var order = u.shuffle(cells.slice());
    order.slice(0, Math.round(order.length * 0.18)).forEach(function (c) { c.className = 'a'; });
    onView(media, function () {
      A.animate(u.shuffle(order), {
        opacity: [1, 0], duration: 240, ease: 'linear',
        delay: A.stagger(Math.max(6, Math.round(620 / order.length))),
        onComplete: function () { if (wrap.parentNode) wrap.parentNode.removeChild(wrap); }
      });
    }, 0.25);
  }
  function decryptHeading(h) {
    if (h._tcDec) return;
    h._tcDec = true;
    var A = window.anime, u = A.utils;
    var original = h.innerHTML, label = h.textContent.replace(/\s+/g, ' ').trim();
    var chars = [];
    var walk = function (node) {
      toArr(node.childNodes).forEach(function (n) {
        if (n.nodeType === 1) return walk(n);
        if (n.nodeType !== 3 || !n.nodeValue.trim()) return;
        var frag = document.createDocumentFragment();
        n.nodeValue.split(/(\s+)/).forEach(function (part) {
          if (!part) return;
          if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
          var wd = document.createElement('span'); wd.className = 'tc-dw';
          Array.from(part).forEach(function (ch) {
            var s = document.createElement('span'); s.className = 'tc-dc'; s.textContent = ch;
            chars.push(s); wd.appendChild(s);
          });
          frag.appendChild(wd);
        });
        n.parentNode.replaceChild(frag, n);
      });
    };
    walk(h);
    if (!chars.length) return;
    h.setAttribute('aria-label', label);
    toArr(h.children).forEach(function (c) { c.setAttribute('aria-hidden', 'true'); });
    u.set(chars, { opacity: 0 });
    onView(h, function () {
      A.animate(u.shuffle(chars.slice()), {
        opacity: [0, 1], filter: ['blur(6px)', 'blur(0px)'], duration: 260, ease: 'outQuad',
        delay: A.stagger(Math.max(12, Math.round(520 / chars.length))),
        onComplete: function () { h.innerHTML = original; h.removeAttribute('aria-label'); }
      });
    }, 0.4);
  }
  function initDecrypt(root) {
    if (reduce) return;
    each(root, PHOTOS, function (m) { if (below(m)) decryptPhoto(m); });
    each(root, '.tc-section .tc-h2:not([data-tc-scramble])', function (h) { if (below(h)) decryptHeading(h); });
  }

  // 5 · Signal signature: a waveform + code generated from each product's ID (same every visit)
  function initSigs(root) {
    var A = window.anime, u = A.utils;
    each(root, '[data-tc-sig]', function (el) {
      if (el._tc) return; el._tc = true;
      var id = parseInt(el.getAttribute('data-tc-sig'), 10) || 1;
      var rnd = u.createSeededRandom(id % 2147483647);
      var n = 26, bw = 2, gap = 1.6, H = 12, x = 0, bars = '';
      for (var i = 0; i < n; i++) {
        var env = Math.sin(Math.PI * (i + 0.5) / n); // taper at both ends, like a pulse
        var bh = Math.max(1.5, rnd(18, 100) / 100 * H * (0.35 + 0.65 * env));
        bars += '<rect x="' + x.toFixed(1) + '" y="' + ((H - bh) / 2).toFixed(2) + '" width="' + bw + '" height="' + bh.toFixed(2) + '" rx="0.5"/>';
        x += bw + gap;
      }
      var code = u.padStart((id % 65536).toString(16).toUpperCase(), 4, '0') + '-' + u.padStart(String(rnd(0, 999)), 3, '0');
      el.innerHTML = '<svg viewBox="0 0 ' + x.toFixed(1) + ' ' + H + '" preserveAspectRatio="none" focusable="false">' + bars + '</svg><span>SIG ' + code + '</span>';
      if (reduce) return;
      var rects = el.querySelectorAll('rect');
      u.set(rects, { scaleY: 0 });
      onView(el.closest('.tc-swipe') || el, function () {
        A.animate(rects, { scaleY: [0, 1], duration: 600, ease: 'outElastic(1, .6)', delay: A.stagger(22, { from: 'center' }) });
      }, 0.5);
    });
  }

  // 6 · Article progress: jumps section to section with a SEC 03/07 readout
  function initProgress() {
    var art = document.querySelector('.article-template');
    if (!art || art._tcProg) return;
    art._tcProg = true;
    var A = window.anime, u = A.utils;
    var body = art.querySelector('.article-block__content') || art;
    var heads = toArr(body.querySelectorAll('h2, h3'));
    var useHeads = heads.length >= 2, n = useHeads ? heads.length : 10;
    var bar = document.createElement('div'); bar.className = 'tc-prog'; bar.setAttribute('aria-hidden', 'true');
    var fill = document.createElement('i'); bar.appendChild(fill);
    for (var k = 1; k < n; k++) { var t = document.createElement('u'); t.style.left = (k / n * 100) + '%'; bar.appendChild(t); }
    var read = document.createElement('div'); read.className = 'tc-prog-read'; read.setAttribute('aria-hidden', 'true');
    document.body.appendChild(bar); document.body.appendChild(read);
    var shown = -1, queued = false;
    var paint = function () {
      queued = false;
      var r = body.getBoundingClientRect(), vh = window.innerHeight;
      var p = u.clamp(u.mapRange(vh * 0.35 - r.top, 0, Math.max(1, r.height - vh * 0.3), 0, 1), 0, 1);
      var sec;
      if (useHeads) {
        sec = heads.filter(function (hd) { return hd.getBoundingClientRect().top < vh * 0.35; }).length;
        if (p >= 0.995 || r.bottom < vh * 0.7 || window.scrollY + vh >= document.documentElement.scrollHeight - 4) sec = n;
      } else {
        sec = Math.round(u.snap(p, 1 / n) * n);
      }
      read.classList.toggle('is-on', r.top < vh * 0.35 && r.bottom > 0);
      if (sec === shown) return;
      shown = sec;
      read.innerHTML = 'SEC <em>' + pad(Math.max(1, sec)) + '</em>/' + pad(n);
      if (reduce) fill.style.transform = 'scaleX(' + (sec / n) + ')';
      else A.animate(fill, { scaleX: sec / n, duration: 420, ease: 'outExpo' });
    };
    window.addEventListener('scroll', function () { if (!queued) { queued = true; requestAnimationFrame(paint); } }, { passive: true });
    window.addEventListener('resize', paint);
    paint();
  }

  function initSignal(root) {
    initDtg(root);
    initReadouts(root);
    initSigs(root);
    initDecrypt(root);
    initRipples(root);
    initLock();
    initProgress();
  }


  /* ---------- Hidden door to the ILL.SIG page: type ILLSIG, or hold the REC light for 3s ---------- */
  function initDoor() {
    var url = window.tcIllDoor;
    if (!url || document.documentElement._tcDoor) return;
    document.documentElement._tcDoor = true;
    var go = function () {
      var A = window.anime, u = A && A.utils;
      if (!A || reduce) { window.location.href = url; return; }
      var el = document.createElement('div'), cols = 10, rows = 6, cells = [];
      el.setAttribute('aria-hidden', 'true');
      el.style.cssText = 'position:fixed;inset:0;z-index:2147483000;display:grid;pointer-events:none;grid-template-columns:repeat(' + cols + ',1fr);grid-template-rows:repeat(' + rows + ',1fr)';
      for (var i = 0; i < cols * rows; i++) {
        var c = document.createElement('span');
        c.style.background = i % 7 === 0 ? '#D4FF3A' : (i % 11 === 0 ? '#FF2E4D' : '#050506');
        cells.push(c); el.appendChild(c);
      }
      u.set(cells, { opacity: 0 });
      document.body.appendChild(el);
      A.animate(u.shuffle(cells.slice()), { opacity: 1, duration: 70, delay: A.stagger(9), onComplete: function () { window.location.href = url; } });
    };
    var code = 'illsig', typed = '';
    document.addEventListener('keydown', function (e) {
      var t = e.target;
      if (t && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName))) return;
      if (!e.key || e.key.length !== 1) return;
      typed = (typed + e.key.toLowerCase()).slice(-code.length);
      if (typed === code) go();
    });
    var rec = document.querySelector('.tc-hero__rec');
    if (rec) {
      var timer = 0;
      rec.style.pointerEvents = 'auto';
      rec.style.touchAction = 'none';
      var cancel = function () { clearTimeout(timer); };
      rec.addEventListener('pointerdown', function () { cancel(); timer = setTimeout(go, 3000); });
      ['pointerup', 'pointerleave', 'pointercancel'].forEach(function (ev) { rec.addEventListener(ev, cancel); });
      rec.addEventListener('contextmenu', function (e) { e.preventDefault(); });
    }
    // Shake the phone. Android: works straight away. iPhone: Safari only shares motion after a tap,
    // so a single tap on the REC light asks for motion access (the light turns green once armed).
    if (window.tcIllShake === false || !window.matchMedia('(pointer: coarse)').matches || typeof window.DeviceMotionEvent === 'undefined') return;
    var armed = false;
    var arm = function () {
      if (armed) return;
      armed = true;
      if (rec) rec.classList.add('is-armed');
      onShake(go, { hits: 3 });
    };
    if (typeof window.DeviceMotionEvent.requestPermission === 'function') {
      if (rec) rec.addEventListener('click', function () {
        window.DeviceMotionEvent.requestPermission().then(function (state) {
          if (state === 'granted') { arm(); if (navigator.vibrate) navigator.vibrate(12); }
        }).catch(function () { /* declined: the hold still works */ });
      });
    } else {
      arm();
    }
  }

  /* Shake detector: counts sharp jolts; fires once `hits` land within 1.3 s */
  function onShake(fn, opts) {
    opts = opts || {};
    var need = opts.hits || 3, hits = [], lx = null, ly = 0, lz = 0, fired = false;
    window.addEventListener('devicemotion', function (e) {
      var a = e.accelerationIncludingGravity || e.acceleration;
      if (!a || a.x == null || fired) return;
      if (lx !== null) {
        var jolt = Math.abs(a.x - lx) + Math.abs(a.y - ly) + Math.abs(a.z - lz);
        var now = Date.now();
        if (jolt > (opts.threshold || 26) && (!hits.length || now - hits[hits.length - 1] > 110)) {
          hits = hits.filter(function (t) { return now - t < 1300; });
          hits.push(now);
          if (opts.each) opts.each(hits.length / need);
          if (hits.length >= need) { hits = []; if (!opts.repeat) fired = true; fn(); }
        }
      }
      lx = a.x; ly = a.y; lz = a.z;
    }, { passive: true });
  }

  function init(root) {
    root = root || document;
    initLogo();
    initMesh(root);
    initSizes(root);
    initCart(root); // works even if animation is off
    whenAnime(function () {
      initHero(root);
      initScramble(root);
      initParticles(root);
      initWave(root);
      initFaq(root);
      initMobile(root);
      initSignal(root);
      initDoor();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  // Theme editor: re-run when a section is added or re-rendered; clean up a removed mesh backdrop
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var id = 'tc-mesh-' + (e.detail && e.detail.sectionId);
    Array.prototype.forEach.call(document.querySelectorAll('body > .tc-mesh, body > .tc-mesh-hud'), function (el) {
      if (el.id === id || el.getAttribute('data-for') === id) { if (el._tcStop) el._tcStop(); el.remove(); }
    });
  });
})();
